import type { SimplifiedPromotion } from 'typings'

export const getStatusInfo = ({
  isActive,
  beginDate,
  endDate,
}: SimplifiedPromotion): {
  id: 'completed' | 'scheduled' | 'running' | 'paused'
  color: 'orange' | 'green' | undefined
} => {
  const now = new Date()
  const beginDateObj = new Date(beginDate)
  const endDateObj = endDate ? new Date(endDate) : undefined

  if (endDateObj && endDateObj.getTime() < now.getTime()) {
    return {
      id: 'completed',
      color: undefined,
    }
  }

  if (isActive) {
    if (beginDateObj.getTime() > now.getTime()) {
      return {
        id: 'scheduled',
        color: 'orange',
      }
    }

    return {
      id: 'running',
      color: 'green',
    }
  }

  return {
    id: 'paused',
    color: undefined,
  }
}
